import React from 'react';
import SEO from '../components/seo';
import HomeHeader from '../components/header/homepage-header';
import Hero from '../components/home-page/hero';
import Highlights from '../components/home-page/01-highlights';
import SimpleCMS from '../components/home-page/02-simplecms';
import AllInOneDashboard from '../components/home-page/03-allinonedashboard';
import StickyNav from '../components/sticky-nav';
import Layout from '../components/layout';

const IndexPage = () => (
  <Layout>
    <SEO title='Restaurant Website Design Agency' />
    <HomeHeader />
    <Hero />
    <Highlights />
    <SimpleCMS />
    <AllInOneDashboard />
    <StickyNav />
  </Layout>
);

export default IndexPage;
